// extracted by mini-css-extract-plugin
export var accountAuditLogHeader = "account-audit-log__header_ynxcnw9IMQOP4IQuLUxg";
export var accountAuditLogLoadingContainer = "account-audit-log__loading-container_lJ8i2rAMY_YUbK7FmYZb";
export var accountAuditLogSectionTitle = "account-audit-log__section-title_bQdo3zgAtzdiKo2lgE4Q";
export var accountAuditLogSeparator = "account-audit-log__separator_c9ubYSiwyaLDAZsrsRPM";
export var accountAuditLogTotalCount = "account-audit-log__total-count_rwAptbRrbNhKBu5gSx1i";